import { createAsyncThunk } from "@reduxjs/toolkit";
import naverApi from 'api/newshub/naverApi';


export const getKeywordsByNormal = async (params: any = {}) => {
  try {
    const response = await naverApi.keywords(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllCategoriesNaverNormal = async (params: any = {}) => {
  try {
    const response = await naverApi.searchCategories(params)
    return response;
  } catch (error) {
    return error;
  }
}
